const InternalManagement = () => {
  return (
    <div style={{ padding: '10px 20px' }}>
      <h1>Internal Management Dashboard</h1>
    </div>
  )
}

export default InternalManagement
